import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Disclaimer from '../../Disclaimer';
import DisclaimerIndicator from '../../../assets/Information.png'
import TextLink from '../../TextLink';
import { getIntelliPriceURL } from '../../../redux/selectors/userAmounts';
import { geti18n } from '../../../utils';

class TradeInInput extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    disclaimerContent: PropTypes.string,
    hasDisclaimer: PropTypes.bool,
    type: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    name: PropTypes.string,
    className: PropTypes.string,
    handler: PropTypes.func.isRequired,
    blurHandler: PropTypes.func,
    intelliPriceURL: PropTypes.string.isRequired,
    intelliPriceText: PropTypes.string,
  };
  static defaultProps = {
    name: '',
    className: '',
    disclaimerContent: '',
    hasDisclaimer: false,
    blurHandler: () => { },
    intelliPriceText: geti18n('personalizePanel.intelliPriceText'),
  };
  render() {
    const {
      title,
      disclaimerContent,
      type,
      value,
      name,
      className,
      handler,
      blurHandler,
      hasDisclaimer,
      intelliPriceText,
      intelliPriceURL
    } = this.props;

    return (
      <div className="personalize-row">
        <div className="personalize-title">
          <p>
            <TextLink url={intelliPriceURL} text={title} target="_blank" classNames="tradein-title-link" linkName="INTELLIPRICE-LINK" />
            <span className="disclaimer-wrapper" aria-hidden={!hasDisclaimer}>
              <Disclaimer indicatorImg={DisclaimerIndicator} classNames="tradein-disclaimer">
                {disclaimerContent}
              </Disclaimer>
            </span>
            <TextLink url={intelliPriceURL} target="_blank" text={intelliPriceText} classNames="tradein-text-link" linkName="INTELLIPRICE-LINK" />
          </p>
        </div>
        <input
          type={type}
          className={className}
          value={value}
          name={name}
          onChange={handler}
          onBlur={blurHandler}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  intelliPriceURL: getIntelliPriceURL(state),
});

export default connect(mapStateToProps)(TradeInInput);



/** WEBPACK FOOTER **
 ** ./src/components/Input/TradeInInput/index.js
 **/